import { Modal, Text, Stack, Flex, Button, Divider } from '@mantine/core';

interface DisableNotificationsConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Modal confirming that user wants to disable all notification channels
 * for job recommendations. Shows warning that they won't receive any notifications.
 */
function DisableNotificationsConfirmModal({
  opened,
  onClose,
  onConfirm,
}: DisableNotificationsConfirmModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton
      title={
        <Text fw={700} size="xl">
          Disable All Notifications?
        </Text>
      }
    >
      <Stack gap="md" align="center" ta="center">
        <Text>
          You are about to disable all notification channels. You will not
          receive any job recommendation notifications.
        </Text>

        <Divider w="100%" />

        <Flex justify="center" gap="sm">
          <Button variant="filled" color="red" onClick={onConfirm} size="sm">
            Disable Notifications
          </Button>
          <Button variant="default" onClick={onClose} size="sm">
            Cancel
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
}

export default DisableNotificationsConfirmModal;
